module.exports = __webpack_public_path__ + "img/sidebarlogo.7cd30723.png";